module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('p', [_vm._v("\n        The sum of potentially missed rewards by BCH miners compared to what they could earn on the BTC chain. Combined, BCH miners have currently missed out on an estimated total of " + _vm._s(_vm.money(_vm.total_cap)) + ".\n    ")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        These numbers are based on blocks that were actually found and not only an estimation based on difficulty/hashrate. The hashrate (or\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pow.speed'
      }
    }
  }, [_vm._v("speed")]), _vm._v(") is accounted for when calculating the difference. There is also a small compensation applied to fees to correct for loss of fee pressure. These numbers are not perfect, only an aproximation but they come close to reality.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Also, this chart does not take into account the future gains in exchange rate of the coins. It assumes miners will sell the coins as soon as possible (hodling is not factored in ;)).\n    ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Once segwit activates on the BTC chain this chart cannot be constructed in a reliable manner anymore (it already is a bit iffy). The chains wil diverge too much to make a sensible comparison between the two. Once that happens this chart will be removed.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-opportunity"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc1aa2e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/opportunity.vue
// module id = 542
// module chunks = 1